import { Component, OnInit, Input } from '@angular/core';
import { SessionsWeek, SessionsWeeksService } from '../../session-weeks.service';

import { camps } from '../../../../models/models.generated';
@Component({
    selector: 'app-purchase-edit-sessions-summary',
    templateUrl: './purchase-edit-sessions-summary.component.html',
    styleUrls: ['./purchase-edit-sessions-summary.component.scss'],
    standalone: false
})
export class PurchaseEditSessionsSummaryComponent implements OnInit {

    @Input()
    public cartSummary: camps.OfficeCartSummaryInfo;

    public weeks: SessionsWeek[];

    constructor(private weekService: SessionsWeeksService) { }

    ngOnInit() {
        this.weeks = this.weekService.createSessionWeeks(this.cartSummary.sessions);
    }

}
